<template>
  <div>
    <section class="landscape-tab-products-wrap clearfix">
      <div class="container">
        <div class="tab-products-header clearfix">
          <ul class="tabs float-left">
            <li
              v-for="(tab, index) in tabs"
              :key="index"
              :class="classes(tab)"
              @click="change(tab)"
            >
              {{ String(tab.label).charAt(0).toUpperCase() + String(tab.label).slice(1).toLowerCase() }}
            </li>
          </ul>
        </div>
        <p v-if="!loading && products.length === 0" class="mt-4 text-center">No Data Found</p>
        <div class="px-100">
          <div class="tab-content landscape-left-tab-products">
            <ProductCard
              class="margin-10"
              v-for="product in products"
              :key="product.id"
              :product="product"
              :isAdmin="isAdmin"
              :daily-purchase-limit-amount="dailyPurchaseLimitAmount"
              :hot-products-disclaimer="hotProductsDisclaimer"
              :target-from-id="'productsTabOneCard'"
              :payment_methods="payment_methods"
            />
          </div>
        </div>


        <dynamic-tab
          v-for="(tabLabel, index) in data"
          :key="index"
          :label="tabLabel"
          :url="route('storefront.tab_products.index', { sectionNumber: 1, tabNumber: index + 1 })"
        >
        </dynamic-tab>
      </div>
    </section>
  </div>
</template>

<script>
import ProductCard from "../ProductCard.vue"
import DynamicTabsMixin from "../../mixins/DynamicTabsMixin"
import { slickPrevArrow, slickNextArrow } from "../../functions"

export default {
  components: { ProductCard },

  mixins: [
    DynamicTabsMixin
  ],

  props: ["data", "isAdmin", "dailyPurchaseLimitAmount", "hotProductsDisclaimer", "payment_methods"],
  methods: {
    selector() {
      return $(".landscape-left-tab-products")
    },

    slickOptions() {
      return {
        rows: 0,
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        rtl: window.Trillion.rtl,
        responsive: [
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 1281,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 920,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  }
}
</script>

<style>
.margin-10 {
  margin: 0 10px;
}
</style>
